import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { getCompanyDepartments } from '@/renderer/services/menuService';

export function useDepartments(outletId?: string | null) {
  return useQuery({
    queryKey: queryKeys.menu.departments(outletId),
    queryFn: async () => {
      const res = await getCompanyDepartments(outletId ?? undefined);
      if (!res.success) {
        throw new Error(res.error ?? 'Failed to fetch departments');
      }

      return res.data ?? [];
    },
    staleTime: 1000 * 60 * 5,
  });
}
